import React from "react";

export default function Nineteen({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <polygon points="249.68 12.68 249.68 15.45 285.62 15.45 285.62 295.71 14.38 295.71 14.38 15.45 47.55 15.45 47.55 12.68 11.61 12.68 11.61 298.49 288.39 298.49 288.39 12.68 249.68 12.68" />
      {children}
    </svg>
  );
}
